// extracted by mini-css-extract-plugin
module.exports = {"uploadButtonContainer":"BulkBidding_uploadButtonContainer__o_5Hs","tooltip":"BulkBidding_tooltip__SNp1H","input":"BulkBidding_input__FJyi_"};